import React from 'react';
import { useGame } from '../context/GameContext';
import { ArrowLeft, Heart } from 'lucide-react';

export default function Credits() {
  const { setScreen } = useGame();
  return (
    <div className="min-h-screen w-full flex flex-col items-center px-6 py-6" data-testid="credits-screen">
      <div className="w-full flex items-center justify-between">
        <button className="brutal-btn text-sm" onClick={() => setScreen('settings')} data-testid="credits-back">
          <ArrowLeft size={16}/> BACK
        </button>
        <h1 className="font-display text-4xl sm:text-5xl font-black uppercase text-[color:var(--pink)]">CREDITS</h1>
        <div className="w-24"/>
      </div>

      <div className="mt-12 max-w-2xl text-center space-y-8">
        <div>
          <div className="text-xs uppercase tracking-[0.4em] text-[color:var(--text-dim)]">GAME</div>
          <div className="font-display text-4xl font-black text-[color:var(--neon)] mt-1">FRIEND SLOP</div>
          <div className="text-xs text-[color:var(--text-dim)] mt-2">v1.0.0 · GOONING TIME</div>
          <div className="text-xs text-[color:var(--text-dim)] mt-1">A cursed brainrot roguelike deckbuilder</div>
        </div>

        <div className="brutal-border p-6 bg-[#0a0a0a]" data-testid="credits-authorship">
          <div className="text-[10px] uppercase tracking-[0.4em] text-[color:var(--text-dim)]">DESIGNED &amp; DEVELOPED BY</div>
          <div className="font-display text-3xl font-black text-[color:var(--pink)] mt-2" data-testid="credits-lead">BLOOMEY</div>
          <div className="mt-4 text-[10px] uppercase tracking-[0.4em] text-[color:var(--text-dim)]">PARTNERED WITH</div>
          <div className="font-display text-xl font-black text-[color:var(--neon)] mt-1" data-testid="credits-partner">ERIC BROOKS</div>
        </div>

        <div className="brutal-border-dim p-6 bg-[#0a0a0a]" data-testid="credits-thanks">
          <div className="text-[10px] uppercase tracking-[0.4em] text-[color:var(--pink)]">SPECIAL THANKS</div>
          <div className="mt-3 font-mono text-sm uppercase text-white leading-relaxed">
            FEFY · NOLAN · MOM · DAD · CLAIRE
          </div>
          <div className="mt-2 font-mono text-sm uppercase text-white leading-relaxed">
            THE DUNGEON STARS SQUAD · LnT
          </div>
        </div>

        <div className="brutal-border p-6 bg-[#0a0a0a]">
          <div className="text-xs uppercase tracking-widest text-[color:var(--pink)]">MADE WITH</div>
          <div className="mt-3 grid grid-cols-2 gap-x-6 gap-y-1 text-sm font-mono uppercase">
            <div>REACT</div><div>FASTAPI</div>
            <div>MONGODB</div><div>TAILWIND</div>
            <div>FRAMER MOTION</div><div>TMI.JS</div>
            <div>SHADCN/UI</div><div>LUCIDE ICONS</div>
          </div>
        </div>

        <div className="text-sm">
          <div className="text-[color:var(--text-dim)] uppercase text-xs tracking-widest">SHOUTOUTS</div>
          <div className="mt-2 flex items-center justify-center gap-2 text-[color:var(--pink)]">
            SLAY THE SPIRE <Heart size={14}/> BALATRO <Heart size={14}/> ISAAC
          </div>
          <div className="mt-1 text-xs text-[color:var(--text-dim)]">for showing the way.</div>
        </div>

        <div className="text-xs text-[color:var(--text-dim)]">
          © 2026 FRIEND SLOP. Cursed with love.
        </div>
      </div>
    </div>
  );
}
